import { render, staticRenderFns } from "./WxChart.vue?vue&type=template&id=19ef0c6d&scoped=true"
import script from "./WxChart.vue?vue&type=script&lang=js"
export * from "./WxChart.vue?vue&type=script&lang=js"
import style0 from "./WxChart.vue?vue&type=style&index=0&id=19ef0c6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ef0c6d",
  null
  
)

export default component.exports